import Swiper, { Autoplay, Pagination, EffectFade, Controller } from 'swiper'

Swiper.use([Autoplay, Pagination, EffectFade, Controller]);

function initTabbedCarousels() {
  const tabbedCarouselBlocks = Array.from(document.querySelectorAll('.js-tabbed-carousel'))

  tabbedCarouselBlocks.forEach(tabbedCarouselBlock => {
    const tabbedCarouselMain = tabbedCarouselBlock.querySelector('.js-tabbed-carousel-main');
    const tabbedSlideCount = tabbedCarouselMain.getAttribute('data-slide-count');
    const paginationEl = tabbedCarouselMain.querySelector('.js-tabbed-carousel-pagination');
    const tabbedCarouselTabs = tabbedCarouselBlock.querySelector('.js-tabbed-carousel-tabs');

    const tabsSwiper = new Swiper(tabbedCarouselTabs, {
      slidesPerView: 1,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      slideToClickedSlide: true,
      loop: true,
      loopedSlides: tabbedSlideCount,
      breakpoints: {
        768: {
          slidesPerView: 3,
        }
      }
    });

    const mainSwiper = new Swiper(tabbedCarouselMain, {
      speed: 800,
      grabCursor: true,
      autoplay: {
        delay: 5000
      },
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      loop: true,
      loopedSlides: tabbedSlideCount,
      pagination: {
        el: paginationEl,
        clickable: true,
      },
    });

    tabsSwiper.controller.control = mainSwiper
    mainSwiper.controller.control = tabsSwiper
  })
}
initTabbedCarousels();
